{
  "available_dates": "Verfügbare Daten",
  "booking_information": "Buchungsbestätigung",
  "choose_your_ship_one": "Schiff",
  "choose_your_ship_other": "Wählen Sie Ihr Schiff",
  "date": "Datum",
  "explanation": "",
  "title": "Preise & Verfügbarkeit",
  "x_th_cabin": "{{ index }}. {{ name }}"
}
